export default __webpack_public_path__ + "static/media/documenttype-icon.f77bf4f8.svg";